import { render, staticRenderFns } from "./WordleCTA.vue?vue&type=template&id=d0e008bc&scoped=true"
import script from "./WordleCTA.vue?vue&type=script&lang=js"
export * from "./WordleCTA.vue?vue&type=script&lang=js"
import style0 from "./WordleCTA.vue?vue&type=style&index=0&id=d0e008bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e008bc",
  null
  
)

export default component.exports